__turbopack_context__.v({
  "slide-in-search": "blog-module-scss-module__aauwRW__slide-in-search",
});
